 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCVI from '@/components/OEBPS/cvi'
 import OEBPSPRA from '@/components/OEBPS/pra'
 import OEBPSALSO from '@/components/OEBPS/also'
 import LOVE_1 from '@/components/love_1'
 import GROVEATLANTICLITHUB from '@/components/grove-atlantic-lithub'
 import OEBPSTP from '@/components/OEBPS/tp'
 import OEBPSCOP from '@/components/OEBPS/cop'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSP1TP from '@/components/OEBPS/p1-tp'
 import OEBPSP1ACK from '@/components/OEBPS/p1-ack'
 import OEBPSP1PRO from '@/components/OEBPS/p1-pro'
 import OEBPSP1C01 from '@/components/OEBPS/p1-c01'
 import OEBPSP1C02 from '@/components/OEBPS/p1-c02'
 import OEBPSP1C03 from '@/components/OEBPS/p1-c03'
 import OEBPSP1C04 from '@/components/OEBPS/p1-c04'
 import OEBPSP1C05 from '@/components/OEBPS/p1-c05'
 import OEBPSP1C06 from '@/components/OEBPS/p1-c06'
 import OEBPSP1C07 from '@/components/OEBPS/p1-c07'
 import OEBPSP1C08 from '@/components/OEBPS/p1-c08'
 import OEBPSP1C09 from '@/components/OEBPS/p1-c09'
 import OEBPSP1C10 from '@/components/OEBPS/p1-c10'
 import OEBPSP1C11 from '@/components/OEBPS/p1-c11'
 import OEBPSP1C12 from '@/components/OEBPS/p1-c12'
 import OEBPSP1C13 from '@/components/OEBPS/p1-c13'
 import OEBPSP1C14 from '@/components/OEBPS/p1-c14'
 import OEBPSP1C15 from '@/components/OEBPS/p1-c15'
 import OEBPSP1C16 from '@/components/OEBPS/p1-c16'
 import OEBPSP1C17 from '@/components/OEBPS/p1-c17'
 import OEBPSP1C18 from '@/components/OEBPS/p1-c18'
 import OEBPSP1C19 from '@/components/OEBPS/p1-c19'
 import OEBPSP1C20 from '@/components/OEBPS/p1-c20'
 import OEBPSP1C21 from '@/components/OEBPS/p1-c21'
 import OEBPSP1EPI from '@/components/OEBPS/p1-epi'
 import OEBPSP2TP from '@/components/OEBPS/p2-tp'
 import OEBPSP2NOTE from '@/components/OEBPS/p2-note'
 import OEBPSP2DED from '@/components/OEBPS/p2-ded'
 import OEBPSP2PRO from '@/components/OEBPS/p2-pro'
 import OEBPSP2P1 from '@/components/OEBPS/p2-p1'
 import OEBPSP2C01 from '@/components/OEBPS/p2-c01'
 import OEBPSP2C02 from '@/components/OEBPS/p2-c02'
 import OEBPSP2C03 from '@/components/OEBPS/p2-c03'
 import OEBPSP2C04 from '@/components/OEBPS/p2-c04'
 import OEBPSP3P2 from '@/components/OEBPS/p3-p2'
 import OEBPSP3C01 from '@/components/OEBPS/p3-c01'
 import OEBPSP3C02 from '@/components/OEBPS/p3-c02'
 import OEBPSP3C03 from '@/components/OEBPS/p3-c03'
 import OEBPSP3C04 from '@/components/OEBPS/p3-c04'
 import OEBPSP3C05 from '@/components/OEBPS/p3-c05'
 import OEBPSP3C06 from '@/components/OEBPS/p3-c06'
 import OEBPSP3C07 from '@/components/OEBPS/p3-c07'
 import OEBPSP3C08 from '@/components/OEBPS/p3-c08'
 import OEBPSP3C09 from '@/components/OEBPS/p3-c09'
 import OEBPSP3C10 from '@/components/OEBPS/p3-c10'
 import OEBPSP3C11 from '@/components/OEBPS/p3-c11'
 import OEBPSP3C12 from '@/components/OEBPS/p3-c12'
 import OEBPSP3C13 from '@/components/OEBPS/p3-c13'
 import OEBPSP3C14 from '@/components/OEBPS/p3-c14'
 import OEBPSP3C15 from '@/components/OEBPS/p3-c15'
 import OEBPSP3C16 from '@/components/OEBPS/p3-c16'
 import OEBPSP3C17 from '@/components/OEBPS/p3-c17'
 import OEBPSP3EPI from '@/components/OEBPS/p3-epi'
 import LOVE_2 from '@/components/love_2'
 import OEBPSINT from '@/components/OEBPS/int'
 import OEBPSPREVIEWPREVIEWTURN from '@/components/OEBPS/Preview/previewturn'
 import OEBPSPREVIEWPREVIEWCOVER from '@/components/OEBPS/Preview/previewcover'
 import OEBPSPREVIEW1979 from '@/components/OEBPS/Preview/1979'
 import OEBPSPREVIEW19791 from '@/components/OEBPS/Preview/1979-1'
 import OEBPSBACK from '@/components/OEBPS/back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cvi",
 			"name" : "OEBPS/cvi",
 			"component" : OEBPSCVI
 		},
 		{
 			"path" : "/OEBPS/pra",
 			"name" : "OEBPS/pra",
 			"component" : OEBPSPRA
 		},
 		{
 			"path" : "/OEBPS/also",
 			"name" : "OEBPS/also",
 			"component" : OEBPSALSO
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/grove-atlantic-lithub",
 			"name" : "grove-atlantic-lithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/OEBPS/tp",
 			"name" : "OEBPS/tp",
 			"component" : OEBPSTP
 		},
 		{
 			"path" : "/OEBPS/cop",
 			"name" : "OEBPS/cop",
 			"component" : OEBPSCOP
 		},
 		{
 			"path" : "/OEBPS/toc",
 			"name" : "OEBPS/toc",
 			"component" : OEBPSTOC
 		},
 		{
 			"path" : "/OEBPS/p1-tp",
 			"name" : "OEBPS/p1-tp",
 			"component" : OEBPSP1TP
 		},
 		{
 			"path" : "/OEBPS/p1-ack",
 			"name" : "OEBPS/p1-ack",
 			"component" : OEBPSP1ACK
 		},
 		{
 			"path" : "/OEBPS/p1-pro",
 			"name" : "OEBPS/p1-pro",
 			"component" : OEBPSP1PRO
 		},
 		{
 			"path" : "/OEBPS/p1-c01",
 			"name" : "OEBPS/p1-c01",
 			"component" : OEBPSP1C01
 		},
 		{
 			"path" : "/OEBPS/p1-c02",
 			"name" : "OEBPS/p1-c02",
 			"component" : OEBPSP1C02
 		},
 		{
 			"path" : "/OEBPS/p1-c03",
 			"name" : "OEBPS/p1-c03",
 			"component" : OEBPSP1C03
 		},
 		{
 			"path" : "/OEBPS/p1-c04",
 			"name" : "OEBPS/p1-c04",
 			"component" : OEBPSP1C04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js